export const PartnershipOfFaith = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="expectMiraclesModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    src="/images/executioners/expectmiracles.jpg"
                    alt="Partnership of Faith 'Expect Miracles' advertisement"
                    style={{ margin: "10px 0" }}
                  />
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      Partnership of Faith
                    </h4>
                    <p style={{ lineHeight: "26px" }}>'Expect Miracles'</p>
                    <p style={{ lineHeight: "13px" }}>
                      Public Service Advertising
                    </p>
                  </div>
                  <div className="modal-body-container">
                    <p className="helvetica-nueue">
                      <strong>OBJECTIVE</strong>
                    </p>
                    <p>
                      Encourage participation in and donations to a new an
                      ecumenical organization to aid New York.
                    </p>
                    <p className="helvetica-nueue">
                      <strong>EXECUTION</strong>
                    </p>
                    <p>
                      We used the apple, (the universally accepted metaphor for
                      New York City, first in it’s most chewed up condition then
                      restored to its full, natural state) in this black and
                      white full page newspaper ad. It declared that “It will
                      take a miracle to save New York”--and then promised to
                      develop and support the programs needed to make the ‘Apple
                      whole again.’ The names of Ministers, Priests, Rabbis and
                      Holy Men from every possible faith were used to
                      demonstrate togetherness and strength.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
